module.exports = __webpack_public_path__ + "static/media/icon-camera.d87d17ca.svg";